import React from 'react';
import PropTypes from 'prop-types';

const LoadingLocker = (props) => (<div className={'loading-locker' + (props.active ? ' is-visible' : '')} />);

LoadingLocker.propTypes = {
    active: PropTypes.bool.isRequired,
};
export default LoadingLocker;